import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import { useLang } from "../../context/LangContext";
import { useV2Session } from "../context/V2SessionContext";
import { getV2Copy } from "../content";
import { validateWeightKg } from "../lib/v2NutritionUtils";

export default function V2GuestEntry() {
  const navigate = useNavigate();
  const { lang } = useLang();
  const { enterGuest } = useV2Session();
  const copy = getV2Copy(lang);
  const [fullName, setFullName] = useState("");
  const [weightKg, setWeightKg] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (loading) return;
    setError("");

    const weightValidation = validateWeightKg(weightKg);
    if (!weightValidation.valid) {
      setError(weightValidation.error);
      return;
    }

    setLoading(true);
    const result = await enterGuest({
      full_name: fullName.trim() || "Guest",
      weight_kg: weightValidation.weightKg,
    });
    setLoading(false);

    if (!result.ok) {
      setError(result.error || "Guest mode could not start.");
      return;
    }
    navigate("/dashboard");
  };

  return (
    <main className="min-h-screen bg-background px-4 py-12 text-foreground">
      <section className="mx-auto max-w-xl rounded-lg border border-border bg-card p-6">
        <h1 className="mt-3 text-3xl font-extrabold">{copy.guest}</h1>
        <p className="mt-3 text-muted-foreground">{copy.guestNotes}</p>
        <p className="mt-3 rounded-lg border border-border bg-background p-3 text-sm font-medium">
          {copy.guestStorageNotice}
        </p>

        <form className="mt-6 space-y-4" onSubmit={handleSubmit}>
          <div className="space-y-2">
            <Label htmlFor="v2-guest-name">{copy.fullName}</Label>
            <Input
              id="v2-guest-name"
              value={fullName}
              onChange={(event) => setFullName(event.target.value)}
              placeholder="Guest"
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor="v2-guest-weight">{copy.weight}</Label>
            <Input
              id="v2-guest-weight"
              type="number"
              min="0"
              step="0.1"
              value={weightKg}
              onChange={(event) => {
                setWeightKg(event.target.value);
                setError("");
              }}
              required
            />
          </div>
          {error && <p className="text-sm font-medium text-destructive">{error}</p>}
          <Button type="submit" disabled={loading}>
            {loading ? "Loading..." : copy.continueGuest}
          </Button>
        </form>
      </section>
    </main>
  );
}
